import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const adsStyle = styled('div')`
  ${media.mobile} {
    padding-bottom: 24px;
  }
  ${media.desktop} {
    padding-bottom: 40px;
  }
  .adsproducts-wrapper {
    ${media.mobile} {
      margin-top: 16px;
    }
  }
  .adsadvantage-wrapper {
    ${media.mobile} {
      margin-top: 100px;
    }
    ${media.desktop} {
      margin-top: 119px;
    }
  }
  .adsemailreceive-wrapper {
    ${media.mobile} {
      margin-top: 32px;
    }
    ${media.desktop} {
      margin-top: 83px;
    }
  }

  .adscomp {
    &--subtitle {
      font-size: 16px;
      font-family: 'Gilroy-ExtraBold';
      color: #ff5500;
      ${media.desktop} {
        font-size: 18px;
      }
    }
    &--title {
      font-size: 24px;
      font-family: 'Pretendard-Bold';
      color: #333333;
      margin-top: 2px;
      ${media.desktop} {
        font-size: 28px;
        margin-top: 4px;
      }
    }
  }
`;
export default adsStyle;
